import { render, staticRenderFns } from "./user-remain.vue?vue&type=template&id=0a466b84&scoped=true"
import script from "./user-remain.vue?vue&type=script&lang=ts"
export * from "./user-remain.vue?vue&type=script&lang=ts"
import style0 from "./user-remain.vue?vue&type=style&index=0&id=0a466b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a466b84",
  null
  
)

export default component.exports